// CSV関連の定数定義

// 実際のCSV項目定義（61項目） - 実際のCSVファイルに合わせた順序
export const EXPECTED_CSV_HEADERS = [
  '成果報酬',                                    // 0
  'カウンセラー対応',                                // 1
  '担当医師',                                    // 2
  'anybot ID',                               // 3
  '診療開始時間',                                  // 4
  'tags',                                    // 5
  'ステータス',                                   // 6
  '会員登録',                                    // 7
  '問診回答',                                    // 8
  '再診用問診',                                   // 9
  '電話番号',                                  // 10
  '診療スタイル',                                  // 11
  '使用ツール',                                   // 12
  '名前（漢字）',                                  // 13
  '名前（カナ）',                                  // 14
  '診療リクエスト',                                 // 15
  '遅延',                                      // 16
  '診療対応',                                    // 17
  '中用量処方有無',                                 // 18
  'アフターピル処方有無',                              // 19
  '副作用改善薬処方有無',                              // 20
  'CS対応必要有無',                                // 21
  '医師からCS/カウンセラー',                           // 22
  'Wチェック',                                   // 23
  'mederi CSから医師へ',                          // 24
  'カウンセラーから医師へ',                             // 25
  '年齢',                                      // 26
  '親への同意',                                   // 27
  '服用経験',                                    // 28
  '服用していたピル',                                // 29
  '改善目的',                                    // 30
  '希望ピル',                                    // 31
  '医師に聞きたいこと',                               // 32
  '※再診問診 医師にききたいこと',                               // 33
  '※再診問診 種類変更希望',                              // 34
  '※再診問診 副作用緩和薬希望',                            // 35
  '前回生理開始日',                                 // 36
  '月経周期',                                    // 37
  '生理を避けたい日にち',                              // 38
  '性行為の日時',                                  // 39
  '妊娠希望',                                    // 40
  '妊娠経験',                                    // 41
  '妊娠時期・出産回数',                               // 42
  '妊娠・出産・授乳有無',                              // 43
  '過去妊娠中に「黄疸」「ヘルペス」「持続性掻疼症」と診断されたことはありますか？', // 44
  '過去2週間以内に手術',                              // 45
  '前兆のある片頭痛',                                // 46
  '飲んでいるお薬',                                 // 47
  'アレルギー',                                   // 48
  '身長',                                      // 49
  '体重',                                      // 50
  'BMIの値は30以下',                              // 51
  '高血圧診断',                                   // 52
  'タバコ',                                     // 53
  '不正出血',                                    // 54
  '婦人科系疾患',                                  // 55
  'その他疾患',                                   // 56
  'ご家族に血栓症',                                 // 57
  'ご家族に乳がん',                                 // 58
  '身分証',                                     // 59
  '採血画像'                                    // 60
];

// 指定された表示順序（EXPECTED_CSV_HEADERSと同じ内容）
// 注意: 実際のCSVファイルのヘッダー名を使用（正規化前の名前）
export const PREFERRED_DISPLAY_ORDER = [
  '成果報酬',                                    // 0
  'カウンセラー対応',                                // 1
  '担当医師',                                    // 2
  'anybot ID',                               // 3
  '診療開始時間',                                  // 4
  'tags',                                    // 5
  'ステータス',                                   // 6
  '会員登録',                                    // 7
  '問診回答',                                    // 8
  '再診用問診',                                   // 9
  '登録電話番号',                                  // 10
  '診療スタイル',                                  // 11
  '使用ツール',                                   // 12
  '名前（漢字）',                                  // 13
  '名前（カナ）',                                  // 14
  '診療リクエスト',                                 // 15
  '遅延',                                      // 16
  '診療対応',                                    // 17
  '中用量処方有無',                                 // 18
  'アフターピル処方有無',                              // 19
  '副作用改善薬処方有無',                              // 20
  'CS対応必要有無',                                // 21
  '医師からCS/カウンセラー',                           // 22
  'Wチェック',                                   // 23
  'mederi CSから医師へ',                          // 24
  'カウンセラーから医師へ',                             // 25
  '年齢',                                      // 26
  '親への同意',                                   // 27
  '服用経験',                                    // 28
  '服用していたピル',                                // 29
  '改善目的',                                    // 30
  '希望ピル',                                    // 31
  '医師に聞きたいこと',                               // 32
  '※再診問診 医師にききたいこと',                               // 33
  '※再診問診 種類変更希望',                              // 34
  '※再診問診 副作用緩和薬希望',                            // 35
  '前回生理開始日',                                 // 36
  '月経周期',                                    // 37
  '生理を避けたい日にち',                              // 38
  '性行為の日時',                                  // 39
  '妊娠希望',                                    // 40
  '妊娠経験',                                    // 41
  '妊娠時期・出産回数',                               // 42
  '妊娠・出産・授乳有無',                              // 43
  '過去妊娠中に「黄疸」「ヘルペス」「持続性掻疼症」と診断されたことはありますか？', // 44
  '過去2週間以内に手術',                              // 45
  '前兆のある片頭痛',                                // 46
  '飲んでいるお薬',                                 // 47
  'アレルギー',                                   // 48
  '身長',                                      // 49
  '体重',                                      // 50
  'BMIの値は30以下',                              // 51
  '高血圧診断',                                   // 52
  'タバコ',                                     // 53
  '不正出血',                                    // 54
  '婦人科系疾患',                                  // 55
  'その他疾患',                                   // 56
  'ご家族に血栓症',                                 // 57
  'ご家族に乳がん',                                 // 58
  '身分証',                                     // 59
  '採血画像'                                    // 60
];

// 指定時間外診療予約データ表示用（61項目）
export const OUT_OF_HOURS_DISPLAY_HEADERS = [
  '成果報酬', '自動プログラム使用', '担当カウンセラー', 'カウンセラー対応', '担当医師',
  'anybot ID', '診療開始時間', 'tags', 'ステータス', '会員登録',
  '問診回答', '再診用問診', '登録電話番号', '診療可能な\n電話番号', '使用ツール',
  '名前（漢字）', '名前（カナ）', '遅延', '診療対応\n※先生は「医師対応完了」のみ選択ください',
  '低用量 / 超低用量ピル /\nミニピル/ 漢方', '中用量ピル', 'アフターピル', '副作用緩和薬',
  'バイク便', 'CS対応内容/医師からCSへ', '処方チェック', 'mederi CSから医師へ',
  '※使わない※\n処方可能医薬品\n※出産経験がある方は、処方条件を確認したうえで処方してください',
  '年齢', '親への同意', '服用経験', '服用していたピル', '改善目的', '希望ピル',
  '医師に聞きたいこと', '※再診用問診\n身分証', '※再診用問診\n予約理由', '※再診用問診\n相談内容詳細',
  '前回生理開始日', '次回生理日', '生理を避けたい日にち', '性行為の日時', '妊娠希望\n（3ヶ月以内）',
  '妊娠経験', '妊娠時期・出産回数', '妊娠・出産・授乳有無',
  '過去妊娠中の既往歴\n\n黄疸\nヘルペス\n持続性掻疼症',
  '過去2週間以内に手術を受けた\nor\n1ヶ月以内に手術の予定があるか',
  '片頭痛', '既往歴\n治療中の病気\n服薬中の薬', 'アレルギー', '身長', '体重', 'BMI',
  '高血圧診断', 'タバコ', '不正出血', '婦人科系疾患の既往歴', 'その他疾患の既往歴',
  'ご家族に血栓症\n（50歳未満）', 'ご家族に乳がん', '身分証', '採血画像'
];

// CSVヘッダーと表示ヘッダーのマッピング
export const CSV_TO_DISPLAY_MAPPING: Record<string, string> = {
  '成果報酬': '成果報酬',
  'カウンセラー対応': 'カウンセラー対応',
  '担当医師': '担当医師',
  'anybot ID': 'anybot ID',
  '診療開始時間': '診療開始時間',
  'tags': 'tags',
  'ステータス': 'ステータス',
  '会員登録': '会員登録',
  '問診回答': '問診回答',
  '再診用問診': '再診用問診',
  '電話番号': '登録電話番号',
  // 古いヘッダー名から新しいヘッダー名へのマッピング
  '診療スタイル': '診療スタイル',
  '名前（漢字）': '名前（漢字）',
  '名前（カナ）': '名前（カナ）',
  '診療リクエスト': '診療リクエスト',
  '診療対応': '診療対応',
  '医師からCS/カウンセラー': '低用量 / 超低用量ピル / ミニピル/ 漢方',
  '中用量処方有無': '中用量ピル',
  'アフターピル処方有無': 'アフターピル',
  '副作用改善薬処方有無': '副作用緩和薬',
  'CS対応必要有無': 'バイク便',
  'Wチェック': '処方チェック',
  'mederi CSから医師へ': 'mederi CSから医師へ',
  'カウンセラーから医師へ': ' CS対応内容/医師からCSへ',
  '年齢': '年齢',
  '親への同意': '親への同意',
  '服用経験': '服用経験',
  '服用していたピル': '服用していたピル',
  '改善目的': '改善目的',
  '希望ピル': '希望ピル',
  '医師に聞きたいこと': '医師に聞きたいこと',
  // 古い※再診問診ヘッダー名から新しいヘッダー名へのマッピング
  '※再診問診 医師にききたいこと': '※再診用問診 身分証',
  '※再診問診 種類変更希望': '※再診用問診 予約理由',
  '※再診問診 副作用緩和薬希望': '※再診用問診 相談内容詳細',
  '前回生理開始日': '前回生理開始日',
  '月経周期': '次回生理日',
  '生理を避けたい日にち': '生理を避けたい日にち',
  '性行為の日時': '性行為の日時',
  '妊娠希望': '妊娠希望（3ヶ月以内）',
  '妊娠経験': '妊娠経験',
  '妊娠時期・出産回数': '妊娠時期・出産回数',
  '妊娠・出産・授乳有無': '妊娠・出産・授乳有無',
  '過去妊娠中に「黄疸」「ヘルペス」「持続性掻疼症」と診断されたことはありますか？': '過去妊娠中の既往歴 黄疸 ヘルペス 持続性掻疼症',
  '過去2週間以内に手術': '過去2週間以内に手術を受けた or 1ヶ月以内に手術の予定があるか',
  '前兆のある片頭痛': '片頭痛',
  '飲んでいるお薬': '既往歴 治療中の病気 服薬中の薬',
  'アレルギー': 'アレルギー',
  '身長': '身長',
  '体重': '体重',
  'BMIの値は30以下': 'BMI',
  '高血圧診断': '高血圧診断',
  'タバコ': 'タバコ',
  '不正出血': '不正出血',
  '婦人科系疾患': '婦人科系疾患の既往歴',
  'その他疾患': 'その他疾患の既往歴',
  'ご家族に血栓症': 'ご家族に血栓症（50歳未満）',
  'ご家族に乳がん': 'ご家族に乳がん',
  '身分証': '身分証',
  '採血画像': '採血画像'
};

// ファイル制約
export const FILE_CONSTRAINTS = {
  MAX_SIZE: 10 * 1024 * 1024, // 10MB
  ALLOWED_EXTENSIONS: ['.csv'],
  SUPPORTED_ENCODINGS: ['UTF-8', 'Shift-JIS']
} as const; 